<template>
    <div class="loginVue">
        <div class="login-wrap">
            <div v-if="!isSubmitedSwitch" class="container">
                <div  v-loading="loading" class="col-md-5 col-sm-12 col-xs-12 login-inner">
                    <div class="row containing-table">
                        <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left">
                            <img src="static/assets/images/logo.png">
                        </div>
                        <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right">
                            <div class="form-group">
                                <div class="clearfix">
                                    <div class="form-group-left o-login-field">
                                        <label>{{ $t('select_union') }}:</label>
                                    </div>
                                    <div class="form-group-right o-login-field o-cutsomSelect">
                                        <!-- <input type="text" class="form-control u-transparent" placeholder="User name or email"> -->
                                        <select v-model="selectedClient" class="form-control u-transparent">
                                            <option value="">{{ $t('select') }} </option>
                                            <option v-for="client in clients" :value="client.client_id" :key="client.client_id">
                                                {{ client.subdomain }} 
                                                <!-- {{ ' ('+client.contact_person+')' }} -->
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="clearfix">
                                    <a @click="goToClientView()" class="c-solid-btn c-solid-btn--green">{{ $t('continue') }} </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="clearfix"></div>
            </div>
            <div class="clearfix"></div>
        </div>

        <modal name="client-switch-modal" :clickToClose="false" height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <!-- <button type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                            <h1 class="modal-title">Add Files</h1> -->
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 10px;">
                                <div class="containing-table">
                                    <div class="col-sm-3 col-xs-12 table-cell text-center o-login-left login-left-spacing">
                                        <!-- <img src="static/assets/images/logo.png"> -->
                                        <img v-if="login_image && login_image != '' && login_image != 'NULL'" :src="login_image" width="100"/>
                                        <img v-if="!login_image || login_image == '' || login_image == 'NULL'" src="static/assets/images/logo.png" width="100" />
                                    </div>
                                    <div class="col-sm-9 col-xs-12 table-cell text-left o-login-right login-right-spacing">
                                        <transition name="">
                                            <div class="login-screen login-right-screen add-word-break-all">
                                                <p v-html="login_text"></p>
                                            </div>
                                        </transition>
                                    </div>
                                </div>
                            </div>
                        <div class="modal-footer text-center">
                            <div class="col-md-12">
                                <ul class="o-filter-area">
                                    <!-- <li>
                                        <a href="javascript: void(0)" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                    </li> -->
                                    <li>
                                        <a href="javascript: void(0)" @click="closeModal()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{ $t('continue') }}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>


                    </div>
                    <!-- /.modal-content -->
                </div>

                <!-- /.modal-dialog -->
            </div>
        </modal>
    </div>
</template>
<script>
    import service from '../services';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../global.js';
    import timeConvertCompare from '../timeConvert&Compare';
    export default {
        computed: {
            ...mapGetters({
                userID: 'userID',
                employeeId: 'employeeId',
                userToken: 'userToken',
                subDomain: 'getSubdomain',
                queryParamClientId: 'queryParamClientId',
                queryParamAppSource: 'queryParamAppSource'
            }),
            
        },
        data() {
            return {
                loading:true,
                clients:[],
                selectedClient:'',
                login_text:'',
                login_image:'',
                client_details:{},
                isSubmitedSwitch:false,
                is_power_steward_allowed: null,
                client_id: '',
                app_source: false
            }
        },
        watch: {},
        methods: {
            closeModal() {
                this.$modal.hide("client-switch-modal");
                let role = this.client_details?this.client_details.role: "";
                let is_steward = this.client_details&&this.client_details.user&&this.client_details.user.employees&&this.client_details.user.employees.length&&this.client_details.user.employees[0].is_steward? this.client_details.user.employees[0].is_steward : false;

                // Determine intended destination
                var self = this;
                var destination = '/jobList';
                if(role.slug == "power-user" || role.slug == "power-user-minus" || (role.slug == "employee" && is_steward&&this.is_power_steward_allowed)){
                    destination = '/jobList';
                }else{
                    let isMobile=service.deviceDetector().isMobile;
                    if(isMobile){
                        this.$cookies.set("csLogin", this.client_details.role.slug, "23h", '/mobile');
                        if(!this.app_source){
                            // For mobile redirect, check policies first then redirect
                            self.checkPendingPoliciesThenNavigate(null, true);
                            this.$modal.hide("client-switch-modal");
                            return;
                        }else {
                            destination = '/schedule/'+btoa(this.employeeId);
                        }
                    }else if(this.subDomain == timeConvertCompare.freelanceSubdomain()){
                        destination = '/myProfile';
                    }else{
                        destination = '/schedule/'+btoa(this.employeeId);
                    }
                }

                // Check for pending privacy policies before navigating
                self.checkPendingPoliciesThenNavigate(destination, false);
                this.$modal.hide("client-switch-modal");
            },
            checkPendingPoliciesThenNavigate(destination, isMobileRedirect) {
                var self = this;
                console.log('[PrivacyPolicy] Checking pending policies. clientId=' + self.selectedClient + ' employeeId=' + self.employeeId);
                var role = self.client_details ? self.client_details.role : null;
                service.get('employee/pendingPrivacyPolicies', {
                    'Authorization': self.userToken,
                    'cs3-context-clientId': self.selectedClient,
                    'cs3-context-employeeId': self.employeeId,
                    'cs3-context-role': role ? role.id : ''
                }).then(function (res) {
                    var pending = res.data.result || [];
                    console.log('[PrivacyPolicy] Pending policies count: ' + pending.length, res.data);
                    if (pending.length > 0) {
                        self.$router.push({
                            path: '/privacy-policy-review',
                            query: { redirect: destination }
                        });
                    } else {
                        if (isMobileRedirect) {
                            window.location.href = window.location.href.split('#')[0] + 'mobile/';
                        } else {
                            self.$router.push({ path: destination });
                        }
                    }
                }).catch(function (err) {
                    console.error('[PrivacyPolicy] Error checking policies:', err);
                    // On error, don't block — proceed normally
                    if (isMobileRedirect) {
                        window.location.href = window.location.href.split('#')[0] + 'mobile/';
                    } else {
                        self.$router.push({ path: destination });
                    }
                });
            },
            openModal() {
                this.$modal.show("client-switch-modal");
            },
            goToClientView(){
                // this.$router.push({
                //     path: "/schedule/"+btoa(this.employeeId),
                // });
                if(this.selectedClient.length != 0) {
                    this.switchClient();
                }
            },
            async getClientAssociationList(){
                this.loading = true;
                await service.get('employee/'+this.userID+'/getEmployeesAssociation', {
                    'Authorization': this.userToken,
                }).then(async(res) => {
                    // console.log(res);
                    this.clients = res.data.result;
                    if(this.app_source) {
                        this.selectedClient = this.client_id;
                        await this.switchClient();
                    } else if(this.clients.length == 1){
                        // await this.switchClient();
                        this.selectedClient = this.clients[0].client_id;
                        await this.switchClient();
                    }
                    // await this.switchClient();
                    this.loading = false;
                }).catch(err =>{
                    this.loading=false
                    console.log(err);
                });
            },
            getLoginGettings(){
                 service.get('client/getClientGreetings', {
                    'Authorization': this.userToken,
                    'clientId': this.selectedClient,
                }).then((res) => {
                    // console.log(res);
                    // this.clients=res.data.result;
                    // this.loading=false;
                }).catch(err =>{
                    // this.loading=false
                    console.log(err);
                });
            },
            async switchClient(){
                this.loading=true;
                // #1466 — tell the backend we're switching tenants so it
                // re-issues the JWT with new client_id + role_id claims.
                // Without this, the cached/JWT context stays on the user's
                // original login tenant and downstream consumers (reports,
                // ALB role routing, any backend that reads from JWT claims
                // or the Valkey cache payload) keep seeing the wrong tenant
                // after a local switch. Mirrors the auth/refresh-token call
                // pattern in api.js — POST + setUserToken on success.
                try {
                    const switchRes = await service.post('auth/switch-client',
                        { client_id: this.selectedClient },
                        { 'Authorization': this.userToken }
                    );
                    const data = switchRes && switchRes.data ? switchRes.data : {};
                    if (data.access_token) {
                        this.$store.dispatch('setUserToken', data.access_token);
                        if (data.expires_at) {
                            this.$store.dispatch('setTokenExpiry', data.expires_at);
                        }
                    }
                } catch (e) {
                    // 403 here means the user has no role for the picked
                    // client; the existing getMUAEmployees call below will
                    // likely fail too and surface its own error. Log for
                    // debugging but don't block the flow.
                    console.warn('[switchClient] backend switch failed:', e && e.message);
                }

                await service.get('employee/getMUAEmployees', {
                    'Authorization': this.userToken,
                    'employeeId': this.employeeId,
                    'clientId': this.selectedClient,
                    'userId': this.userID
                }).then((res) => {
                    this.loading=false;
                    // console.log('switchClient',res.data.result);
                    localStorage.removeItem('vuex');
                    this.client_details = res.data.result;
                    // console.log(this.client_details);
                    this.$cookies.set("csLogin", this.client_details.role.slug, "23h");
                    // #1559 (1B): the powerSteward cookie must mean "this user is a power
                    // steward ON THE ACTIVE CLIENT" = is_steward && clients.power_steward,
                    // NOT clients.power_steward alone (the client-wide toggle). getMUAEmployees
                    // returns employees[0].is_steward (Steward skill on the switched client).
                    // checkAccess() AND the #1559 router gate both key off this cookie, so this
                    // keeps route-access and feature-access aligned with a TRUE power steward
                    // and blocks a non-steward employee at a power-steward-enabled client.
                    var __psEmp = this.client_details.user.employees[0];
                    var __isSteward = (__psEmp && __psEmp.is_steward) ? 1 : 0;
                    var __clientPs = (__psEmp && __psEmp.client_employee && __psEmp.client_employee.clients && __psEmp.client_employee.clients.power_steward) ? 1 : 0;
                    this.$cookies.set("powerSteward", (__isSteward && __clientPs) ? 1 : 0, "23h");
                    this.$store.dispatch('onSwitchClient', this.client_details);
                    this.login_image = this.client_details.user.employees[0].client_employee.clients.login_image;
                    var rawMsg = this.client_details.user.employees[0].client_employee.clients.login_page_message || '';
                    this.login_text = rawMsg.replace(/<a /g, '<a target="_blank" rel="noopener" ');
                    this.is_power_steward_allowed = this.client_details.user.employees[0].client_employee.clients.power_steward;
                    this.isSubmitedSwitch=true;
                    this.openModal();
                    this.getLoginGettings();
                    if(this.app_source && this.client_id != ''){
                        this.closeModal();
                        // this.$store.dispatch('setQueryParamClientId', this.client_id); queryParamClientId: 'queryParamClientId',
                        //   queryParamAppSource: 'queryParamAppSource'
                        // this.$store.dispatch('setQueryParamAppSource', this.app_source);
                    }
                    /* END CHAT SUPPORT */
                }).catch(err =>{
                    this.loading=false
                    console.log(err);
                });
            }
        },
        mounted() {},
        beforeMount() {},
           
        async created() {
            this.app_source = this.$route.query.app_source ? this.$route.query.app_source : false;
            this.client_id = this.$route.query.client_id ? this.$route.query.client_id : '';
            await this.getClientAssociationList();
            // if(this.app_source&&this.client_id!='') {
            //     this.selectedClient = this.client_id;
            //     this.switchClient();
            // } else {
            //      this.getClientAssociationList();  
            // }
        }
    }

</script>
<style scoped>
.o-cutsomSelect select {
    background-color: #335478 !important;
}
.login-wrap .form-control {
    padding-left: 5px;
    color: #ffffff;
    font-weight: 600;
    letter-spacing: 1px;
}
.login-wrap .form-control option {
    font-size: 14px;
    font-weight: 600;
    padding-left: 5px !important;
    color: #fff !important;
    letter-spacing: 1px;
}
.add-word-break-all{
    word-break: break-all;
}
</style>
